import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import './index.css';
import { hydrateThemeFromStorage } from '@/theme/domTheme';

hydrateThemeFromStorage();

const googleClientId = (import.meta.env.VITE_GOOGLE_CLIENT_ID ?? '').trim();

const root = (
  <React.StrictMode>
    {googleClientId ? (
      <GoogleOAuthProvider clientId={googleClientId}>
        <App />
      </GoogleOAuthProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

if (!googleClientId && import.meta.env.DEV) {
  console.info('[auth] VITE_GOOGLE_CLIENT_ID non defini : connexion Google desactivee.');
}

ReactDOM.createRoot(document.getElementById('root')!).render(root);

const enableServiceWorker = import.meta.env.VITE_ENABLE_SW === 'true';

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    if (!enableServiceWorker) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      });
      return;
    }

    navigator.serviceWorker
      .register(`${import.meta.env.BASE_URL}sw.js`)
      .then((registration) => {
        console.log('SW registered:', registration.scope);
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
}
